import React, { Component } from 'react';
import { Layout } from '$components/account';
import { logout } from '$actions/accounts';
import { connect } from 'react-redux';

@connect(null, { logout })
export default class LayoutRoute extends Component {
  render() {
    const { logout } = this.props;

    return (
      <Layout onLogout={logout}>
        {this.props.children}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/layout.js